import React, { useState } from 'react';
import './ContactForm.css';
import "../../index.css"

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    projectType: '',
    projectDetails: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form Data Submitted:', formData);
  };

  return (
    <div className="contact-form-container">
      <h2 className="contact-form-title local-clr-dark-red">Get in Touch</h2>
      <p className="contact-form-subtitle local-clr-dark-blue">
        Tell us a little about the project and we'll take it from there.
      </p>

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="name" >
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="company">Company <span className="optional">(optional)</span></label>
          <input
            type="text"
            id="company"
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="projectType">Project Type</label>
          <select
            id="projectType"
            name="projectType"
            value={formData.projectType}
            onChange={handleChange}
            required
          >
            Personal · Family · Professional Headshots · Model · Glamour
            <option value="" disabled>Select one</option>
            <option value="persona">Personal</option>
            <option value="family">Family</option>
            <option value="professional-headshots">Professional Headshots</option>
            <option value="event">Model</option>
            <option value="glamour">Glamour</option>
            <option value="something-else">Something else</option>
          </select>
        </div>

        <div className="form-group full-width">
          <label htmlFor="projectDetails">The Project</label>
          <textarea
            id="projectDetails"
            name="projectDetails"
            rows="5"
            value={formData.projectDetails}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <button type="submit" className="submit-button">
          Send It Over
        </button>
      </form>

      <p className="contact-footer local-clr-dark-red">
        Prefer email? <a className="local-clr-dark-blue" href="mailto:info@rosebornefilmandphoto.com">info@rosebornefilmandphoto</a>
      </p>
    </div>
  );
}
